// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ViewBar-root__lnAHh{display:flex;flex-direction:row;gap:var(--size-2);align-items:center;justify-content:space-between;height:var(--size-13);padding:var(--size-0) var(--size-4);border-bottom:var(--size-0_25) solid var(--gray-a3)}.ViewBar-start__WFF1R{display:flex;flex:1;align-items:center;min-width:var(--size-0);overflow-x:hidden}.ViewBar-end__cKtp1{display:flex;flex-direction:row;flex-shrink:0;gap:var(--size-2);align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "ViewBar-root__lnAHh",
	"start": "ViewBar-start__WFF1R",
	"end": "ViewBar-end__cKtp1"
};
export default ___CSS_LOADER_EXPORT___;
